import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../Constants';  // Import the base URL from Constants.js

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const query = useQuery();
    const token = query.get('token');

    useEffect(() => {
        if (!token) {
            setError('Token is missing from the URL');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!token) {
            setError("Token is missing");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/reset-password?token=${encodeURIComponent(token)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ newPassword, confirmPassword }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'An error occurred');
            }

            const data = await response.json();
            setMessage(data.message || 'Password has been reset successfully!');
        } catch (error) {
            setError(error.message || 'An error occurred');
        }
    };

    return (
        <div className="gradient-bg" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <div className="logo-container" style={{ textAlign: 'center' }}>
                <h2 style={{ color: '#FFD800', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Reset Password</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        value={newPassword}
                        className="input-custom"
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter your new password"
                        required
                        style={{ marginBottom: '10px' }} // Add margin for spacing
                    />
                    <input className="input-custom"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm your new password"
                        required
                        style={{ marginBottom: '10px' }} // Add margin for spacing
                    />
                    <button className="login-button" type="submit">Submit</button>
                </form>
                {message && <p style={{ color: 'green' }}>{message}</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className="login-links" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <a href="/login" style={{ textDecoration: 'underline' }}>Back to Login</a>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
